<template>
  <div class="camera-container">

    <!-- نمایش ویدئو -->
    <video ref="video" autoplay playsinline class="camera-preview"></video>

    <!-- دکمه گرفتن عکس + فیلد توضیحات (در یک ردیف) -->
    <div class="capture-row">
      <div class="capture-col">
        <BaseButton title="عکس برداری" variant="success" @click="capturePhoto">
          <template #icon>
            <font-awesome-icon icon="fa-solid fa-camera" />
          </template>
        </BaseButton>
      </div>

      <div class="description-field">
        <textarea
          v-model="description"
          placeholder="توضیحات (اختیاری)"
          class="description-input"
          rows="3"
        ></textarea>
      </div>
    </div>

    <!-- نمایش thumbnails -->
    <div v-if="photos.length">
      <div class="image-upload-area">
        <div class="image-placeholder">
          <div class="thumbnails">
            <div v-for="(photo, index) in photos" :key="index" class="thumbnail-item">
              <img :src="photo" class="thumbnail-img" @click="viewPhoto(index)" />
              <button class="delete-btn" @click.stop="deletePhoto(index)">
                <font-awesome-icon :icon="['fa-solid', 'trash-can']" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- نمایش عکس در ابعاد بزرگتر -->
    <div v-if="selectedPhoto !== null" class="photo-modal" @click="selectedPhoto = null">
      <img :src="photos[selectedPhoto]" class="large-photo" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'

// Props
// eslint-disable-next-line no-undef
const props = defineProps({
  recordId: {
    type: [String, Number],
    required: true
  }
})

// Emits
// eslint-disable-next-line no-undef
const emit = defineEmits(['confirm', 'close'])
// eslint-disable-next-line no-undef
defineExpose({ confirm });

// Refs
const video = ref(null)
const stream = ref(null)
const photos = ref([])
const selectedPhoto = ref(null)
const description = ref('')
// شروع دوربین
async function startCamera() {
  try {
    stream.value = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment' }
    })
    if (video.value) {
      video.value.srcObject = stream.value
    }
  } catch (err) {
    console.error(err)
  }
}

// گرفتن عکس
function capturePhoto() {
  if (!video.value) return
  const canvas = document.createElement('canvas')
  canvas.width = video.value.videoWidth
  canvas.height = video.value.videoHeight
  const ctx = canvas.getContext('2d')
  ctx.drawImage(video.value, 0, 0, canvas.width, canvas.height)
  const photoData = canvas.toDataURL('image/png')
  photos.value.push(photoData)
}

// مشاهده عکس بزرگ
function viewPhoto(index) {
  selectedPhoto.value = index
}

// حذف عکس
function deletePhoto(index) {
  photos.value.splice(index, 1)
  if (selectedPhoto.value === index) {
    selectedPhoto.value = null
  }
}

// ✅ تابع confirm به‌روز شده:
function confirm() {
  // تبدیل Base64 به File
  const files = photos.value.map((dataUrl, index) => {
    const arr = dataUrl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `photo_${index + 1}.png`, { type: mime })
  })

  return {
    recordId: props.recordId,
    photos: files, // فایل‌های واقعی
    description: description.value
  }
}

onMounted(() => {
  startCamera()
})

onBeforeUnmount(() => {
  if (stream.value) {
    stream.value.getTracks().forEach(track => track.stop())
  }
})
</script>

<style scoped>
.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.camera-preview {
  width: 300px;
  height: auto;
  border-radius: 8px;
  background: #000;
  margin: 30px;
}

.capture-row {
  width: 100%;
  max-width: 600px;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
}

.capture-col {
  flex: 0 0 auto;
}

@media (max-width: 768px) {
  .capture-row {
    flex-direction: column;
    align-items: stretch;
  }

  .capture-col {
    width: 100%;
  }
}





.upload-input {
  margin-top: 10px;
}

.description-field {
  width: 100%;
  max-width: 400px;
  margin: 15px 0;
  flex: 1 1 auto;
}

.description-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  font-family: inherit;
  direction: rtl;
  height: 40px;
}

.thumbnails {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: 7px;
  justify-content: right;
  margin-bottom: 12px;
}

.thumbnail-item {
  position: relative;
  width: 70px;
  height: 70px;
  border: 2px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 7px;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: rgba(58, 57, 57, 0.8);
  color: white;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s ease;
}

.delete-btn:hover {
  background-color: rgba(200, 0, 0, 0.9);
}

.delete-btn svg {
  width: 12px;
  height: 12px;
}

.photo-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.large-photo {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
}

.image-upload-area {
  margin-top: 10px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background-color: #f9fafb;
  min-height: 20px;
  width: auto;
}

.image-placeholder {
  text-align: center;
  color: #6b7280;
  cursor: pointer;
}

.image-placeholder span {
  font-size: 48px;
  line-height: 1;
}

/* مخفی کردن input اصلی */
.upload-input {
  display: none;
}

/* استایل دکمه */
.upload-btn {
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #4caf50;
  /* سبز */
  color: #fff;
  padding: 10px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.upload-btn:hover {
  background-color: #43a047;
  /* سبز تیره‌تر */
}

.upload-btn:active {
  background-color: #388e3c;
}
</style>
